/* eslint-disable no-console */
class ExpandedPromo {
  constructor(options) {
    if (!options.callbacks) {
      options.callbacks = {};
    }
    this.onOpen = options.callbacks.onOpen;
    this.onClose = options.callbacks.onClose;
    this.promoDiv = document.querySelector(`#${options.id}`);
    this.isOpen = false;
    this.previousElementInFocus = null;
    // Modal events
    this.promoDiv.querySelector('.close-btn').addEventListener('click', this.close.bind(this));
    document.addEventListener('keyup', this.onDocumentModalKeyUp.bind(this));
    // Add open to toggleBtn
    if (options.toggleBtn) {
      options.toggleBtn.addEventListener('click', this.open.bind(this));
    }
  }

  onDocumentModalKeyUp(event) {
    if (event.keyCode === 27 && this.isOpen) {
      this.close(); /* eslint-disable-line no-use-before-define */
    }
  }

  setPreviousElementInFocus(element) {
    this.previousElementInFocus = element;
  }

  resetFocus() {
    if (this.previousElementInFocus) {
      this.previousElementInFocus.focus();
    }
  }

  close() {
    this.isOpen = false;
    if (this.onClose) {
      this.onClose();
    }
    this.promoDiv.classList.remove('is-expanded');
    this.resetFocus();
  }

  open() {
    this.isOpen = true;
    this.promoDiv.classList.add('is-expanded');
    if (this.onOpen) {
      this.onOpen();
    }
    this.setPreviousElementInFocus(document.activeElement);
    this.promoDiv.focus();
  }
}

export default () => {
  const onDocumentClick = (event) => {
    const { target } = event;
    const toggleBtn = target.closest('.slide-expand-promo-btn');
    if (!toggleBtn) {
      return;
    }
    const id = toggleBtn.getAttribute('aria-controls');
    let promo = new ExpandedPromo({
      id,
      callbacks: {
        onClose: () => {
          promo = null;
        },
      },
    });
    promo.open();
  };

  document.addEventListener('click', onDocumentClick);
};
/* eslint-enable no-console */
